<template>
  <div class="wrapper">
    <page>
      <template v-if="type == 'mobile'">
        <h1 class="fsl32">{{fr == 'wx' ? $t('Login.text1'): $t('Login.text2')}}</h1>
        <div class="content-box">
          <login-mobile ref="$vm_login_mobile" :is_hide_send_btn="true" @send_status="send_status"></login-mobile>
        </div>
        <div
          class="btn-group relative flex-justify-content-space-between flex-align-items-center mt-80-48 mq"
        >
          <btn class="size48 mq" :text="is_sent ? $t('Login.text10') : $t('Login.text11')"  @click.native="login_check"></btn>
          <div v-if="fr != 'wx'" class="forget-btn-box flex-box flex-justify-content-space-between">
            <router-link :to="{name:'forgot'}" class="black-3 gl-hover-text">{{$t('Login.text3')}}</router-link>
            <router-link
              :to="{name:'login'}"
              class="black-3 gl-hover-text tab-login-type-btn"
            >{{$t('Login.text4')}}</router-link>
          </div>
        </div>
      </template>
      <template v-else>
        <h1 class="fsl32">{{$t('Login.text5')}}</h1>
        <div class="content-box">
          <div class="mt-48-32 mq">
            <input
              type="text"
              name="account"
              v-model="account"
              class="gl-input"
              :placeholder="$t('Login.text6')"
            >
          </div>
          <div class="mt-48-32 mq">
            <input
              type="password"
              name="password"
              v-model="password"
              class="gl-input"
              @keyup.enter="login"
              :placeholder="$t('Login.text7')"
            >
          </div>
        </div>
        <div
          class="btn-group relative flex-justify-content-space-between flex-align-items-center mt-80-48 mq"
        >
          <btn class="size48 mq" @click.native="login">{{$t('Login.text5')}}</btn>
          <div class="forget-btn-box flex-box flex-justify-content-space-between">
            <router-link :to="{name:'forgot'}" class="black-3 gl-hover-text">{{$t('Login.text8')}}</router-link>
            <router-link
              :to="{name:'login', query:{type: 'mobile'}}"
              class="black-3 gl-hover-text tab-login-type-btn"
            >{{$t('Login.text9')}}</router-link>
          </div>
          <i v-if="this.GL.ENV.is_wechat || browser_size != 'small'" class="afd afd-wechat fs24 pointer" @click="wx_login"></i>
        </div>
        <!-- <div id="wx-login-box"></div> -->
      </template>
    </page>
  </div>
</template>

<script>
import { POST_LOGIN } from '@/api/config';
import { mapState } from 'vuex';
export default {
  name: 'login',
  metaInfo() {
        let tit = `登录爱发电 | 爱发电`;
        let key = `爱发电，订阅，创作者，赞助，粉丝，视频，文章，小说，音乐，绘画，动漫，摄影，游戏，艺术`;
        let desc = `将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。`;
        let url = location.href;
        return {
            title: tit,
            meta: [
                {
                    name: "keywords",
                    content: key,
                },
                {
                    property:'og:title',
                    content: tit,
                },
                {
                    property:'og:description',
                    content: desc,
                },
                {
                    property:'og:url',
                    content: url,
                }
            ],
        };
  },
  data() {
    // window.aaaa =  this.$router;
    // window.b = this.$route.query.origin_path;
    let fix_origin_path = this.$route.query.origin_path || ''
    let is_sku_order_from_wechat_login = fix_origin_path != '' && location.search.indexOf('sku') != -1  && location.search.indexOf('response_type') != -1
    if(is_sku_order_from_wechat_login){
      let arr = decodeURIComponent(location.search).split('&');
      let plan_id = '';
      let sku = '';
      arr.forEach(v => {
        let key_value = v.split('=');
        if(key_value && key_value[0] == 'plan_id'){
            plan_id = key_value[1];
        }
        if(key_value && key_value[0] == 'sku'){
            sku = key_value[1];
        }
      })
      fix_origin_path = `/order/create?product_type=${this.$route.query.product_type}&plan_id=${plan_id}&sku=${sku}`
    }
    return {
      account: '',
      password: '',
      fr: this.$route.query.fr || '',
      code: this.$route.query.code || '',
      state:this.$route.query.state || '',
      is_sent: false,
      type: this.$route.query.type || '',
      origin_path: fix_origin_path //this.$route.query 解析复杂参数有问题
    };
  },
  watch: {
    session_user(val) {
      // if(val && val.has_bind_phone == 0 && this.GL.ENV.is_wechat){
      //   this.$router.push(`/login?type=mobile&fr=wx`)
      //   return false;
      // }
      if(this.GL.ENV.is_afd_client){
        this.$bridge.call("history_close", {}, e => {});
        return false;
      }
      if(this.origin_path){
        this.$router.replace({ path: this.origin_path });
        return false;
      }
      if (this.redirect_url) {

        this.$router.replace({ path: this.redirect_url });
        this.$store.commit('app/set:redirect_url', '');
        return false;
      }
      if (val) {
        this.$router.push('/feed');
      }
    },
    redirect_url(v){
      this.check_open_wx_login_modal()
    }
  },
  computed: {
    ...mapState('app', ['session_user','browser_size', 'redirect_url', 'mp_token','wx_oauth_landpage']),
    share_config(){
        return {
            url: window.location.href,
            source: `${location.origin}`,
            title: `登录爱发电 | 爱发电`,
            description: `将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。`,
            pic: `https://static.afdiancdn.com/static/img/logo/logo.png`,
        };
    },
  },
  mounted() {
    if(this.origin_path){
      return false;
    }
    this.check_open_wx_login_modal()
    this.$mixin_share(this.share_config)
    if(this.$refs.$vm_login_mobile){
      this.is_sent = this.$refs.$vm_login_mobile.is_sent;
    }
  },
  methods: {
    send_status(status) {
      this.is_sent = status;
    },
    wx_login(){
      if(!this.check_open_wx_login_modal()){
        return false;
      }
    //   window.afd_wx_login(this.wx_oauth_landpage)
      let top = parseInt(window.innerHeight / 2 - 250);
      let left = parseInt(window.innerWidth / 2 - 300);
      window.afd_wx_login_window = window.open('/oauth/wechat', 'newwindow', `height=500, width=600, top=${top},left=${left}, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`);
      this.$bus.$emit('WX_LOGIN',{
        redirect_uri: this.wx_oauth_landpage
      });
    },
    check_open_wx_login_modal(){
      if(!this.session_user && !this.type && !this.code && this.GL.ENV.is_wechat){
        let uri = this.redirect_url;
        this.$modal.hide('ModalWxLogin')
        this.$mixin_show_modal_wx_login({
          redirect_url:uri.indexOf('http') == -1 ? `https://afdian.net/login?origin_path=${uri}` : uri,
        })
        return false;
      }
      return true;
    },
    async login() {
      this.$store.dispatch('app/del:session_user');
      if (this.$http.is_run(POST_LOGIN)) {
        return false;
      }
      let data = await this.$http.$axios(POST_LOGIN, {
        account: this.account.trim(),
        password: this.password,
        mp_token: this.mp_token
      });

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error'
        });
        return false;
      }
      this.$bus.$emit('SESSION_LOGIN', data.data.auth_token);
    },
    async login_check() {
      if (!this.is_sent) {
        let confirm = await this.$refs.$vm_login_mobile.send();
        if (!confirm) {
          return false;
        }
      } else {
        let confirm = await this.$refs.$vm_login_mobile.confirm();
        if (!confirm) {
          return false;
        }
      }
      if(this.fr == 'wx'){
        let uri = this.redirect_url;
        if(uri){
          this.$router.replace({ path: uri });
        }else{
          this.$router.replace({ path: `/feed` });
        }
        this.$store.commit('app/set:redirect_url', '');
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.wrapper {
  .content-box {
    margin-top: px2rem(32);
  }

  .btn-group {
    display: flex;
  }

  .tab-login-type-btn {
    position: absolute;
    left: 0;
    top: px2rem(96);
    z-index:1;
  }

  .vm-page {
    padding-bottom: 150px;
  }
  .afd-wechat{
    position: absolute;
    left: 0;
    top: 130px;
    z-index:1;
  }
  // #wx-login-box{
  //   position:fixed;
  //   left:50%;
  //   top:50%;
  //   width:300px;
  //   height:300px;
  //   transform:translate(-50%,-50%);
  //   border:1px solid;
  // }

  @media (max-width: $width-mobile) {
    .btn-group {
      display: block;
    }

    .forget-btn-box {
      margin-top: px2rem(24);
      display: flex;
      flex-direction: row-reverse;
    }

    .vm-page /deep/ {
      .page-box {
        padding: 0 px2rem(32);
      }
    }

    .content-box {
      margin-top: px2rem(24);
    }

    .tab-login-type-btn {
      position: relative;
      left: auto;
      top: auto;
    }
  }
}
</style>